// src/api/hourlyLogApi.js
import apiClient from './axios';

const hourlyLogApi = {
  // GET all with pagination + search
  // getAll: async (page = 1, pageSize = 10, search = '', employee = '') => {
  //   const response = await apiClient.get('/hourly-work-management/', {
  //     params: { page, page_size: pageSize, search, employee },
  //   });
  //   return response.data; // { data: [...], pagination: { ... } }
  // },

  getAll: async (page = 1, pageSize = 10, search = '', employee = '') => {
    const response = await apiClient.get('/hourly-work-management/shifts/', {
      params: {
        page,
        page_size: pageSize,
        search,
        employee,
      },
    });
    return response.data; // { status, success, data: [shifts], pagination, errors }
  },
  
  // CREATE
  create: async (data) => {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });

    const response = await apiClient.post('/hourly-work-management/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // UPDATE (only send changed fields)
  update: async (id, data) => {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });

    const response = await apiClient.patch(`/hourly-work-management/${id}/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // DELETE
  delete: async (id) => {
    await apiClient.delete(`/hourly-work-management/${id}/`);
    return id;
  },

  // EXPORT CSV
  exportCsv: async () => {
    const response = await apiClient.get('/hourly-work-management/export/', {
      responseType: 'blob',
    });
    return response.data;
  },

  // IMPORT PREVIEW
  importPreview: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const response = await apiClient.post('/hourly-work-management/import-preview/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // IMPORT CONFIRM
  importConfirm: async (preview) => {
    const response = await apiClient.post('/hourly-work-management/import-confirm/', { preview });
    return response.data;
  },
};

export default hourlyLogApi;